@if (!isPreviewMode) {
  @if (showForm && isSubTask && nameControl) {
    <textarea
      #nameInput
      aria-label="Task Name"
      autocomplete="off"
      cdkTextareaAutosize
      class="sub-task-header-fields__title-input"
      cols="1"
      data-qa="task-header-name-textarea"
      id="task-name"
      matInput
      rows="2"
      [cdkAutosizeMaxRows]="2"
      [maxlength]="nameMaxLength"
      [class.edit-mode]="showForm"
      [class.readonly-input]="isReadOnly || !showForm"
      [class.invalid]="nameControl.invalid && nameControl.touched"
      [placeholder]="namePlaceholder"
      [readonly]="isReadOnly || !showForm"
      [formControl]="nameControl">
    </textarea>
    @if (nameControl.invalid && nameControl.touched) {
      <div class="sub-task-header-fields__field-error">Title is required.</div>
    }
  } @else {
    <h2 class="sub-task-header-fields__title">
      {{ displayName && displayName.trim() ? displayName : namePlaceholder }}
    </h2>
  }
}
@if (showForm && isSubTask && descriptionControl) {
  <textarea
    #descriptionInput
    aria-label="Task Description"
    autocomplete="off"
    cdkTextareaAutosize
    class="sub-task-header-fields__description-input"
    cols="1"
    data-qa="task-header-description-textarea"
    id="task-description"
    matInput
    rows="2"
    [class.edit-mode]="showForm"
    [class.readonly-input]="isReadOnly || !showForm"
    [class.invalid]="descriptionControl.invalid && descriptionControl.touched"
    [placeholder]="descriptionPlaceholder"
    [readonly]="isReadOnly || !showForm"
    [formControl]="descriptionControl"
    [cdkAutosizeMaxRows]="descriptionMaxRows || undefined">
  </textarea>
  @if (descriptionControl.invalid && descriptionControl.touched) {
    <div class="sub-task-header-fields__field-error">Instructions are required.</div>
  }
} @else {
  <div class="sub-task-header-fields__description">
    {{
      displayDescription && displayDescription.trim() ? displayDescription : 'Provide instructions for this sub task'
    }}
  </div>
}
